import GeoService from "@global/utilities/global-geo-service.js";

export default {
    setDealerResults: ({commit}, payload) => {
        commit('setDealerResults', payload);
    },
    setMapCenter: ({commit}, payload) => {
        if (payload.lat && payload.lng) {
            commit('setMapCenter', payload);
        } else {
            console.error('mapCenter must contain lat and lng keys');
        }
    },
    setMapZoom: ({commit}, payload) => {
        commit('setMapZoom', payload);
    },
    setUserLocation: ({commit}, payload) => {
        if (payload === null || payload.lat && payload.lng) {
            commit('setUserLocation', payload);
        } else {
            console.error('mapCenter must contain lat and lng keys');
        }
    },
    setCountry: ({commit, dispatch}, payload) => {
        commit('setCountry', payload)
        dispatch('calculateAvailableFilters')
    },
    setCity: ({commit}, payload) => {
        commit('setCity', payload)
    },
    setRadius: ({commit}, radius) => {
        commit('setRadius', radius)
    },
    requireEmail: ({commit}, payload) => {
        commit('requireEmail', !!payload)
    },
    setTypeFilter: ({commit}, payload) => {
        commit('setTypeFilter', payload)
    },
    calculateAvailableFilters: ({commit, getters}) => {
        const availableFilters = getters.dealerTypes.reduce((acc, dealerType) => {
            // Check if there is any dealer of this type
            if (!getters.getDealersInCountry.some(dealer => dealer.dealerTypes.includes(dealerType.identifier))) {
                return acc;
            }
            // Map to filter object
            acc.push({
                name: dealerType.identifier,
                label: dealerType.name,
                selected: false
            })
            return acc;
        }, [])

        if (availableFilters.length > 0) {
            commit("setAvailableFilters", availableFilters)
        }
    },
    findDealersByFilter: ({state, getters, dispatch}) => {
        GeoService.getLatLng(`${state.city} ${state.country}`)
            .then(userLocation => {
                let resultDealers = getters.getFilteredDealers;

                // Filter by distance
                let maxDistance = 10000000; // 10 000 km
                if (state.radius.key !== -1) {
                    maxDistance = state.radius.key;
                }

                resultDealers = resultDealers.filter(dealer => {
                    const distance = GeoService.getDistance(dealer.geo, userLocation);
                    dealer.distance = distance;
                    return distance <= maxDistance;
                });

                dispatch('setDealerResults', resultDealers);
                dispatch('setMapCenter', userLocation);
                dispatch('setUserLocation', userLocation);
            }).catch(error => {
                console.error("Fetching user Location failed", error);
            })
    }
};
